import * as Actions from 'app/store/actions/table/table.actions';

const initialState = {
	highligthRow: null,
};

const tableReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.HIGHLIGHT_ROW: {
            //console.log('REDUCERS TABLE:', action.payload)
			return {
				...state,
				highligthRow: action.payload,
			};
		}
		
		default: {
			return state;
		}
	}
};

export default tableReducer;
